// extracted by mini-css-extract-plugin
module.exports = {"general":"style_general__1raR4","modalLeftRight":"style_modalLeftRight__1v_N-","modalFade":"style_modalFade__2f3Io","cross":"style_cross__3jOnY","easyZoom":"style_easyZoom__2-YRA"};